export const DOWNLOAD_PLATFORMS = [
  {
    icon: '/assets/intro/ios-icon.svg',
    iconBg: '#e0f5f6',
    link: 'https://apps.apple.com/am/app/vinni/id1569213680',
    btnIcon: '/assets/footer/app.png',
  },
  {
    icon: '/assets/intro/android-icon.svg',
    iconBg: '#3ecfb2',
    link: 'https://play.google.com/store/apps/details?id=am.dynamic.vinni',
    btnIcon: '/assets/footer/google.png',
  },
];